export default "__VITE_ASSET__0PgJxXqjw$KAl6PgZjQb5g__ 220w, __VITE_ASSET__yW_eMvu1QqHghXJHMLbBbg__ 440w, __VITE_ASSET__EsSyonNWXFChOyjfj2S3nw__ 600w";